import PasswordEyeHiddenIcon from "./PasswordEyeHiddenIcon";
import PasswordEyeVisibleIcon from "./PasswordEyeVisibleIcon";

const PasswordToggleIcon = ({ visible, className = "", ...props }) =>
    visible ? (
        <PasswordEyeVisibleIcon className={className} {...props} />
    ) : (
        <PasswordEyeHiddenIcon className={className} {...props} />
    );

export default PasswordToggleIcon;
